import { render, staticRenderFns } from "./EnacAtplDashboardPhaseSide.vue?vue&type=template&id=47881603"
import script from "./EnacAtplDashboardPhaseSide.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports